import React, { FunctionComponent } from 'react'
import { Pane, majorScale, Button, IntentTypes } from 'evergreen-ui'

interface DialogLayoutProps {
  backLabel?: string
  onBackClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  confirmLabel?: string
  confirmDisabled?: boolean
  confirmIntent?: IntentTypes
  onConfirmClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const DialogLayout: FunctionComponent<DialogLayoutProps> = props => {
  const {
    backLabel = 'Back',
    onBackClick,
    confirmLabel = 'Confirm',
    confirmDisabled,
    confirmIntent,
    onConfirmClick,
    children
  } = props

  return (
    <>
      <Pane padding={majorScale(3)}>{children}</Pane>

      {(onBackClick || onConfirmClick) && (
        <Pane display="flex" justifyContent="flex-end" padding={majorScale(2)} borderTop>
          {onBackClick && (
            <Button type="button" onClick={onBackClick}>
              {backLabel}
            </Button>
          )}
          {onConfirmClick && (
            <Button
              type="button"
              appearance="primary"
              disabled={confirmDisabled}
              intent={confirmIntent}
              onClick={onConfirmClick}
              marginLeft={majorScale(1)}
            >
              {confirmLabel}
            </Button>
          )}
        </Pane>
      )}
    </>
  )
}

export default DialogLayout
